<template>
  <section class="services py-5">
    <div class="container">
      <div class="section-title text-center mb-5">
        <span class="subtitle">Unsere Expertise</span>
        <h2>Maßgeschneiderte <span class="text-gradient">Lösungen</span> für Ihren Erfolg</h2>
      </div>
      
      <!-- Service-Kategorien Tabs -->
      <div class="service-tabs mb-4">
        <div class="filter-buttons">
          <button 
            class="filter-btn" 
            :class="{ 'active': activeCategory === 'all' }" 
            @click="setCategory('all')"
          >
            Alle
          </button>
          <button 
            class="filter-btn" 
            :class="{ 'active': activeCategory === 'ai' }" 
            @click="setCategory('ai')"
          >
            KI & Automatisierung
          </button>
          <button 
            class="filter-btn" 
            :class="{ 'active': activeCategory === 'devops' }" 
            @click="setCategory('devops')"
          >
            DevOps & Cloud
          </button>
          <button 
            class="filter-btn" 
            :class="{ 'active': activeCategory === 'it' }" 
            @click="setCategory('it')"
          >
            IT-Infrastruktur
          </button>
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-4 mb-4" v-for="service in filteredServices" :key="service.title">
          <div class="card h-100 custom-card" :class="service.effect">
            <div class="card-body d-flex flex-column align-items-center justify-content-center">
              <div class="service-icon mb-3" v-if="service.icon">
                <i :class="service.icon"></i>
              </div>
              <div class="service-icon mb-3" v-else>
                <svg v-if="service.category === 'ai'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M290.3 73.8c18-1 35.3 4.9 49 16.6C353.6 102.3 362 120.8 364 140c2.4 23.7-5.1 48.3-20.7 66.8c-8.6 10.3-19.8 18.2-32.4 23c-16 6.4-34.1 7.7-51 3.8c25.1-12.9 39.7-38.3 38.9-66c-.5-16.6-6.2-33-16.6-45.9c-11.6-14.4-28.6-23.9-46.8-25.7c-17.6-1.6-35.5 3.7-49.6 14.5c-11.7 8.7-20.6 21.1-25.7 35c-6.3 17.3-5.3 36.3 1.3 53.2c-7.9 9.8-18.9 16.8-31.1 20.8c-15.8 4.8-32.7 4.3-48.2-1.4c-7.5-2.7-14.4-6.8-20.4-12c-15.6-13.1-25.2-32.5-26.4-52.7c-.8-13.3 2.6-26.6 9.2-38.1c13.2-23.1 39.1-37.4 66-37.3c1.9 0 3.9 .1 5.8 .3c11.5 1 22.6 4.3 32.7 9.6c-2-10.3-1.7-21.1 .7-31.2C150.3 13.2 177.3 .8 204.3 .7c30.2-.1 59.3 16.9 73.6 43.4c2.8 5.2 5 10.6 6.5 16.2c1.9 6.8 2.9 13.8 3.3 20.8c.3 14.6-3 30.8-13.1 41.5c-7.8 8.2-19.7 12.9-31.2 11.2c-19.7-2.8-33.7-21.9-30.4-41.6c1.9-13.3 12.9-25 26.4-26.2c5.6-.5 11.4 .5 16.3 3.3c5 2.8 9 7.3 10.9 12.9c2.1 6.1 1.8 13.2-1.1 19.5c-3.1 6.8-9.7 11.6-16.9 12.7c-.6 .1-2 0-2-1c0-.6 .6-1 1.2-1.1c9.6-1.7 16.7-11.5 15.5-21.6c-1.3-9.5-9.2-17.3-18.7-19c-9.2-1.8-19.2 2.4-24.2 10.3c-5.7 8.8-5 21.2 1.7 29.2c7 8.5 19.1 11.6 29.9 9.1c15.3-3.4 27-16.3 30.5-31.5c2.8-11.9 1.9-24.4-2.6-35.7c-5.7-14.2-16.7-25.5-30.7-31.3C225.3 12.3 207.2 11.8 191 18c-10.9 4.2-20.6 11.8-27.4 21.4c-13.2 18.5-16.3 43.4-8.2 64.7c1.9 5.1 4.4 9.9 7.5 14.3c2.7 3.9 5.8 7.4 9.2 10.6c1.4 1.3-.5 3.6-1.9 2.4c-7.5-6.5-13.5-14.7-17.2-24c-7.5-18.5-6.6-39.3 1.5-57.3C162.7 33.2 178.2 20.7 196 15c17.2-5.5 35.7-3.2 51.5 5c13.4 7 24.4 18.9 30.6 33.2c5.9 13.7 7.6 29.2 5 44.2c-3.6 20.9-17.2 38.8-35.2 48.9c11.3 2.1 22.9 2 34-1c17.5-4.9 32.9-16.3 43.3-31.4c16.1-22.9 19.9-53.3 9.8-79.7c-7.3-19.1-22.2-34.3-41.1-42.1c1.5 5.3 2.2 10.8 2.2 16.3c0 7.2-1.3 14.4-3.8 21.1c3.7 4.2 6.9 8.9 9.6 13.8c8.6 16.1 12.1 35.4 7.5 53c-3.9 15.1-13.6 27.9-26.8 35.7c-.8 .5-1.9-.4-1.4-1.3c13.2-23.5 9.5-55.3-9.5-75.4c-10.5-10.9-24.7-17.7-39.4-19.1c-13.9-1.2-27.8 2.1-39.7 9.3c-23.5 14.3-37.2 42.5-32.1 70c.9 4.6 2.1 9.1 3.8 13.5c5.6 .7 11.1 2 16.5 3.8c18.1 6.1 33.7 19.5 41.7 37c9.1 20.2 8.2 44.7-3.2 63.8c-9 15.2-23.9 26.5-40.9 31.4c-12.6 3.7-26.1 4.1-39.3 1.3c-35.3-7.3-62.3-39-65.4-75c-2.2-25.7 7.5-50.9 25.9-68.4c-21-7.9-45.2-7.1-66.2 2.3c-17.1 7.5-31.7 21.2-40.3 37.7C.1 183.5-2.1 196.8 2.3 213.3c3.3 12.5 9.7 24 18.8 33c12.9 12.9 30.6 20.2 48.9 20c10.6 0 21.3-2.3 31-6.9c13.3-6.2 23.9-17.1 29.3-30.7c-30.2-60.6 33.7-125.8 98.1-115.5c6.2 1 12.2 2.7 17.8 5.1c6.5 2.8 12.3 6.7 17.3 11.6c15.6 15.5 21.4 38.2 15.4 59.2c-6.8 23.3-26.6 42.2-50.2 47.5c-20.2 4.7-41.6 .5-58.2-10.2c-8.3 6.1-18.1 10.1-28.4 11.6c-18.6 2.5-37.4-2.8-51.8-14.6c-13.7-11.4-22.9-28.1-25.3-46c-3.5-24.2 6.3-48.7 25-64.5c15.7-13.4 36.2-20.4 56.9-19.5c21.9 1.1 42.4 11.5 55.9 28c21.7-6.5 41-20.2 53.7-38.7c.5-.8 1.8-.4 1.8 .5c0 9.2-1.1 18.4-3.8 27.2c9.2 10.8 14.8 24.5 16.4 38.8c2.4 20.6-3.8 41.7-16.8 57.5c-12.5 15.4-30.2 25.8-49.8 29.2c-16.2 2.9-33 1.2-48.2-4.9c-17.6-6.8-32.8-19.4-42.4-35.7c-5-8.5-8.4-17.8-10.2-27.4c-3.7 8.5-7.1 17.6-6.8 27c.7 25.5 20.9 47.8 46.2 52.3c18 3.3 36.7-1.9 51.1-13.2c24.5-19.2 34.3-54 23.1-83.8c-8.3-21.8-26.5-39-49.5-44.8c-2.9-.7-5.9-1.3-8.9-1.7c-4.7 9.9-11.1 18.9-19 26.5c4.1 2.4 7.9 5.2 11.5 8.3c14.4 12.7 24 31.2 25.3 50.4c1.9 28.7-13.5 57.1-39.1 71.4c-12.9 7.2-27.8 10.3-42.6 9c-22.6-2-43.5-13.8-56.3-32.4c-10.8-15.8-15.3-35.7-11.8-54.4C91.2 208.1 107.9 191 128.3 184c-14.1-20.2-16.7-47.7-4.4-70.4c8-14.8 21.2-26.6 36.9-32.6C137.1 61.5 120.3 41.6 113.2 16.1c-1-3.4 4.2-4.9 5.2-1.5c5.6 20.5 18.7 37.6 36.6 47.5c1.1-2.3 2.4-4.5 3.7-6.6c9.8-15.1 24.5-25.6 41.5-30.8c17.3-5.4 35.6-3.7 52 3.8c9.3 4.2 17.8 10.4 24.7 18.1c1.6 1.8 3 3.7 4.4 5.7c.8 1.3 2.5 1.3 3.4 0c9.4-16.5 27.3-25.8 46.5-24.5z"/>
                </svg>
                <svg v-else-if="service.category === 'devops'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.8 3.2 7.8 6.1 12.1 8.6l-37.8 207.7c-26.5 3.7-49.3 20.2-61.2 43.1L111.1 269.9c11.7-8 21.5-18.7 28.5-30.9l16.7-6.7zM80 208a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm80 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM400 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M0 96C0 60.7 28.7 32 64 32H196.1c19.1 0 37.4 7.6 50.9 21.1L289.9 96H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H286.6c-10.6 0-20.8-4.2-28.3-11.7L213.5 87.5c-4.5-4.5-10.6-7-17-7H64z"/>
                </svg>
              </div>
              <h3 class="card-title text-uppercase">{{ service.title }}</h3>
              <p class="card-text">{{ service.description }}</p>
              <button class="btn btn-primary mt-auto" @click="openModal(service)">Mehr Details</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="selectedService" class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ selectedService.title }}</h5>
            <button type="button" class="close" @click="closeModal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>{{ selectedService.fullDescription }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Schließen</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AppServices",
  data() {
    return {
      selectedService: null,
      activeCategory: 'all',
      services: [
  // KI & Automatisierungslösungen
  {
    title: "LLM-Integration & RAG",
    description: "Nutzen Sie die Leistung von Large Language Models mit Retrieval-Augmented Generation für Ihr Unternehmen.",
    fullDescription: "Unsere LLM-Integrationslösungen mit RAG verbinden fortschrittliche Sprachmodelle mit Ihren Unternehmensdaten. Wir implementieren maßgeschneiderte Retrieval-Augmented Generation (RAG) Systeme, die relevante Informationen aus Ihren Dokumenten extrahieren und mit der Wissensgenerierung von LLMs kombinieren. Dies ermöglicht präzise, kontextualisierte und aktuelle Antworten auf komplexe Anfragen. Unsere Lösungen reduzieren Halluzinationen um bis zu 95% und steigern die Informationsgenauigkeit erheblich. Typische Anwendungen umfassen intelligente Dokumentensuche, Chatbots mit Unternehmenswissen und automatisierte Inhaltsanalyse.",
    icon: "fas fa-brain",
    category: "ai",
    effect: "effect-blur"
  },
  {
    title: "KI-gestützte Prompt-Entwicklung",
    description: "Maximieren Sie die Qualität Ihrer KI-Interaktionen durch strukturiertes Prompt Engineering.",
    fullDescription: "Mit unseren Pydantic AI-basierten Prompt-Engineering-Lösungen optimieren wir die Interaktion mit KI-Modellen für konsistente und qualitativ hochwertige Ergebnisse. Wir implementieren robuste Typisierung und Validierung für Prompts, wodurch die Zuverlässigkeit und Effizienz Ihrer KI-Anwendungen deutlich verbessert wird. Unsere strukturierten Prompt-Templates ermöglichen wiederverwendbare Komponenten mit klaren Input- und Output-Definitionen. Diese Methodik hat in Kundenprojekten die Entwicklungszeit um 40% reduziert und die Qualität der KI-generierten Inhalte um 60% verbessert. Die Lösung ist besonders wertvoll für komplexe KI-Anwendungen in Unternehmensumgebungen.",
    icon: "fas fa-comments",
    category: "ai",
    effect: "effect-shadow"
  },
  {
    title: "Vektordatenbank & Semantische Suche",
    description: "Implementieren Sie moderne Embedding-basierte Systeme für intelligente Informationssuche.",
    fullDescription: "Unsere Vektordatenbank-Lösungen (Pinecone, Vecs) transformieren die Art, wie Unternehmen Informationen suchen und abrufen. Durch die Verwendung von Embeddings und semantischer Ähnlichkeit ermöglichen wir Suchanfragen, die den Inhalt und die Bedeutung von Dokumenten verstehen, nicht nur Stichwörter. Die Implementierung erfolgt durch Tokenisierung und Vektorisierung von Texten, deren Speicherung in optimierten Vektordatenbanken und die Entwicklung von intuitiven Abfrageschnittstellen. Kunden berichten von einer um 70% verbesserten Informationsauffindbarkeit und einem ROI von 300% durch die Zeitersparnis bei der Informationssuche.",
    icon: "fas fa-chart-line",
    category: "ai",
    effect: "effect-border"
  },
  {
    title: "Generative KI für Medien",
    description: "Nutzen Sie KI für die Erstellung hochwertiger Bilder, Videos und Audioformate.",
    fullDescription: "Mit unseren generativen KI-Lösungen für Medien können Unternehmen hochwertige visuelle und auditive Inhalte effizient erstellen. Wir integrieren Technologien wie Vibe AI für Bild- und Videoerzeugung, verbunden mit maßgeschneiderten Prompt-Optimierungssystemen. Die Lösungen umfassen automatisierte Content-Erstellung für Marketing, Produktvisualisierungen und Designkonzepte. Durch unsere Implementierung können Kunden den Content-Erstellungsprozess um bis zu 80% beschleunigen, Produktionskosten um 65% senken und gleichzeitig die Konsistenz der Markenidentität sicherstellen. Alle Systeme werden mit ethischen Leitlinien und rechtlichen Compliance-Mechanismen ausgestattet.",
    icon: "fas fa-eye",
    category: "ai",
    effect: "effect-glow"
  },
  
  // DevOps und Cloud-Lösungen
  {
    title: "DevOps Transformation",
    description: "Modernisieren Sie Ihre Entwicklungs- und Betriebsprozesse für mehr Agilität und Effizienz.",
    fullDescription: "Unsere DevOps-Transformationsdienste helfen Ihnen, eine Kultur der Zusammenarbeit zwischen Entwicklung und Betrieb zu schaffen. Wir bewerten Ihre bestehenden Prozesse, identifizieren Verbesserungspotenziale und implementieren Best Practices für eine nahtlose Integration von Entwicklung, Qualitätssicherung und Betrieb. Die Ergebnisse: schnellere Markteinführung neuer Features (durchschnittlich 70% Verkürzung der Entwicklungszyklen), höhere Softwarequalität und bessere Zusammenarbeit im Team. Unser ganzheitlicher Ansatz umfasst sowohl technische Implementierungen als auch kulturelle Veränderungen für nachhaltige Erfolge.",
    icon: "fas fa-infinity",
    category: "devops",
    effect: "effect-blur"
  },
  {
    title: "CI/CD Pipeline-Optimierung",
    description: "Automatisieren Sie Ihre Software-Delivery-Pipeline für schnellere und zuverlässigere Releases.",
    fullDescription: "Unsere CI/CD-Optimierungsdienste automatisieren den gesamten Prozess von der Code-Entwicklung bis zur Produktionsbereitstellung. Wir implementieren und konfigurieren moderne CI/CD-Tools wie Jenkins, GitLab CI/CD, GitHub Actions oder Azure DevOps und integrieren automatisierte Tests und Sicherheitsscans. Durch die Implementierung unserer CI/CD-Pipelines haben Kunden die Release-Häufigkeit um das 10-fache erhöht, die Fehlerrate um 80% reduziert und die Bereitstellungszeit von Tagen auf Minuten verkürzt. Unsere Pipelines sind skalierbar, wartbar und anpassbar an Ihre spezifischen Anforderungen.",
    icon: "fas fa-code-branch",
    category: "devops",
    effect: "effect-shadow"
  },
  {
    title: "Cloud-native Architektur",
    description: "Entwickeln und migrieren Sie Anwendungen für optimale Performance in der Cloud.",
    fullDescription: "Unsere Cloud-native Architekturdienste helfen Ihnen, Anwendungen zu entwickeln oder zu modernisieren, die die volle Leistungsfähigkeit der Cloud ausnutzen. Wir setzen auf Microservices, Containerisierung, serverlose Architekturen und automatische Skalierung, um hochverfügbare, elastische und ausfallsichere Systeme zu schaffen. Unsere Experten unterstützen Sie bei der Auswahl der richtigen Cloud-Plattform (AWS, Azure, GCP) und implementieren Best Practices für Sicherheit, Kostenoptimierung und Leistung. Der Umstieg auf eine Cloud-native Architektur hat bei unseren Kunden zu Kosteneinsparungen von durchschnittlich 40% und einer Verbesserung der Systemverfügbarkeit auf 99,99% geführt.",
    icon: "fas fa-cloud",
    category: "devops",
    effect: "effect-border"
  },
  {
    title: "Kubernetes Orchestrierung",
    description: "Maximieren Sie die Effizienz und Skalierbarkeit Ihrer containerisierten Anwendungen.",
    fullDescription: "Unsere Kubernetes-Experten helfen Ihnen, komplexe containerisierte Anwendungen effizient zu verwalten und zu skalieren. Wir implementieren und konfigurieren Kubernetes-Cluster (selbst verwaltet oder als verwalteter Service), definieren Deployment-Strategien und konfigurieren automatische Skalierung und Selbstheilung. Unsere Kubernetes-Lösungen umfassen auch fortschrittliches Monitoring, Logging und Service Mesh für eine verbesserte Beobachtbarkeit und Resilienz. Mit unserer Kubernetes-Implementierung haben Kunden eine Ressourcennutzungseffizienz von über 80% erreicht, die Ausfallzeiten um 95% reduziert und die Kosten für die Infrastruktur signifikant gesenkt.",
    icon: "fas fa-cubes",
    category: "devops",
    effect: "effect-glow"
  },
  
  // IT-Infrastruktur
  {
    title: "Hybride Cloud-Strategien",
    description: "Entwickeln Sie eine optimale Balance zwischen On-Premise und Cloud-Ressourcen.",
    fullDescription: "Unsere hybriden Cloud-Strategiedienste helfen Ihnen, eine maßgeschneiderte Multi-Cloud-Umgebung zu entwickeln, die Ihre spezifischen Geschäftsanforderungen erfüllt. Wir bewerten Ihre bestehende Infrastruktur, identifizieren Workloads für die Cloud-Migration und entwickeln eine detaillierte Roadmap für die Transformation. Unsere hybriden Cloud-Lösungen kombinieren die Sicherheit und Kontrolle lokaler Umgebungen mit der Skalierbarkeit und Agilität der öffentlichen Cloud. Wir implementieren auch fortschrittliche Netzwerk- und Sicherheitslösungen für eine nahtlose Integration zwischen verschiedenen Umgebungen. Die Umsetzung unserer hybriden Cloud-Strategie hat Kunden eine Kosteneinsparung von 30-50% bei gleichzeitiger Verbesserung der Agilität und Resilienz ermöglicht.",
    icon: "fas fa-server",
    category: "it",
    effect: "effect-blur"
  },
  {
    title: "Infrastruktur-Automatisierung",
    description: "Automatisieren Sie die Bereitstellung und Verwaltung Ihrer gesamten IT-Infrastruktur.",
    fullDescription: "Mit unseren Infrastruktur-Automatisierungsdiensten können Sie Ihre gesamte IT-Infrastruktur als Code definieren und verwalten. Wir implementieren Tools wie Terraform, Ansible und CloudFormation, um die Bereitstellung, Konfiguration und Verwaltung Ihrer Infrastruktur zu automatisieren. Dies ermöglicht eine konsistente, wiederholbare und version-kontrollierte Infrastruktur, die sich bei Bedarf schnell skalieren lässt. Die Implementierung von Infrastructure as Code hat bei unseren Kunden die Zeit für die Bereitstellung neuer Umgebungen von Wochen auf Stunden reduziert, menschliche Fehler eliminiert und die Compliance verbessert. Unsere Automatisierungslösungen decken Compute, Netzwerk, Speicher und Sicherheit ab und sind für hybride und Multi-Cloud-Umgebungen optimiert.",
    icon: "fas fa-robot",
    category: "it",
    effect: "effect-shadow"
  },
  {
    title: "Zero-Trust Sicherheitsarchitektur",
    description: "Implementieren Sie ein modernes Sicherheitsmodell für Ihre gesamte IT-Landschaft.",
    fullDescription: "Unsere Zero-Trust-Sicherheitsdienste helfen Ihnen, ein umfassendes Sicherheitsmodell zu implementieren, das auf dem Prinzip 'niemals vertrauen, immer verifizieren' basiert. Wir entwerfen und implementieren Mikrosegmentierung, Identity and Access Management, Verschlüsselung und kontinuierliche Validierung für alle Benutzer und Systeme, unabhängig von ihrem Standort. Unsere Zero-Trust-Architektur schützt vor fortgeschrittenen Bedrohungen, reduziert die Angriffsfläche und ermöglicht sichere Remote-Arbeit. Die Implementierung unseres Zero-Trust-Modells hat bei Kunden die Erkennung von Sicherheitsvorfällen um 90% verbessert und die Reaktionszeit auf Vorfälle um 80% verkürzt. Wir bieten auch kontinuierliche Sicherheitsbewertungen und Anpassungen an die sich ständig weiterentwickelnde Bedrohungslandschaft.",
    icon: "fas fa-lock",
    category: "it",
    effect: "effect-border"
  },
  {
    title: "Disaster Recovery & Business Continuity",
    description: "Sichern Sie die Kontinuität Ihres Unternehmens mit robusten DR-Lösungen.",
    fullDescription: "Unsere Disaster Recovery und Business Continuity-Dienste helfen Ihnen, umfassende Pläne und Systeme zu entwickeln, die die Kontinuität Ihres Unternehmens im Falle von Störungen sicherstellen. Wir entwerfen und implementieren automatisierte Backup- und Wiederherstellungssysteme, Replikationslösungen und Failover-Mechanismen, die auf Ihre spezifischen Recovery Time Objectives (RTO) und Recovery Point Objectives (RPO) abgestimmt sind. Unsere DR-Lösungen nutzen Cloud-Technologien für Kosteneffizienz und Zuverlässigkeit und werden regelmäßig getestet, um ihre Wirksamkeit zu gewährleisten. Mit unseren DR-Lösungen haben Kunden ihre Wiederherstellungszeiten von Tagen auf Stunden reduziert und die Datenwiederherstellungsfähigkeit auf nahezu 100% verbessert.",
    icon: "fas fa-life-ring",
    category: "it",
    effect: "effect-glow"
  }
]
    };
  },
  computed: {
    filteredServices() {
      if (this.activeCategory === 'all') {
        return this.services;
      }
      return this.services.filter(service => service.category === this.activeCategory);
    }
  },
  methods: {
    setCategory(category) {
      this.activeCategory = category;
    },
    openModal(service) {
      this.selectedService = service;
    },
    closeModal() {
      this.selectedService = null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

.services {
  padding: 80px 0;
  background: linear-gradient(180deg, darken($background-color, 3%), $background-color);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI0MDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IHgxPSIxMDAlIiB5MT0iMjEuODgxJSIgeDI9IjUwJSIgeTI9IjEwMCUiIGlkPSJhIj48c3RvcCBzdG9wLWNvbG9yPSIjMURBQUU0IiBzdG9wLW9wYWNpdHk9Ii4wNSIgb2Zmc2V0PSIwJSIvPjxzdG9wIHN0b3AtY29sb3I9IiMxREFBRTQiIHN0b3Atb3BhY2l0eT0iMCIgb2Zmc2V0PSIxMDAlIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHBhdGggZD0iTTAgMGgxNDQwdjMwMEwwIDQwMHoiIGZpbGw9InVybCgjYSkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgb3BhY2l0eT0iLjIiLz48L3N2Zz4=');
    background-size: cover;
    background-position: center bottom;
    opacity: 0.1;
    z-index: 0;
  }
}

.service-tabs {
  margin-bottom: 3rem;
  
  .filter-buttons {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
    background: rgba($secondary-color, 0.4);
    padding: 0.75rem;
    border-radius: 50px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    
    .filter-btn {
      color: $muted-text-color;
      background: transparent;
      border: none;
      border-radius: 50px;
      padding: 0.6rem 1.5rem;
      font-weight: 600;
      font-size: 0.9rem;
      transition: all 0.3s ease;
      cursor: pointer;
      
      &:hover {
        color: $text-color;
        transform: translateY(-2px);
      }
      
      &.active {
        background: $accent-gradient;
        color: white;
        box-shadow: 0 4px 12px rgba($accent-color, 0.3);
      }
    }
  }
}

.service-icon {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-bottom: 1.5rem;
  font-size: 1.75rem;
  background: $accent-gradient;
  color: white;
  box-shadow: 0 8px 20px rgba($accent-color, 0.3);
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
    border-radius: 50%;
    border: 1px solid rgba($accent-color, 0.3);
    animation: pulse 2s infinite;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.custom-card {
  background: rgba($secondary-color, 0.4);
  border-radius: 15px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
  transition: all 0.4s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(5px);
  border: 1px solid rgba($accent-color, 0.1);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 6px;
    background: $accent-gradient;
    opacity: 0;
    transition: opacity 0.4s ease;
  }

  &:hover {
    transform: translateY(-15px);
    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.2);
    border-color: rgba($accent-color, 0.3);
    
    &::before {
      opacity: 1;
    }
  }

  .card-title {
    font-size: 1.2rem;
    font-weight: bold;
    color: $heading-color;
    margin-bottom: 15px;
    text-align: center;
  }

  .card-text {
    font-size: 0.9rem;
    color: $muted-text-color;
    text-align: center;
    padding: 0 10px;
    margin-bottom: 1.5rem;
  }
}

button {
  background: $accent-gradient;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba($accent-color, 0.3);
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba($accent-color, 0.4);
  }
}

.modal-content {
  background: $modal-background;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba($accent-color, 0.1);
  backdrop-filter: blur(10px);
}

.modal-header {
  border-bottom: 1px solid rgba($accent-color, 0.1);
  padding: 1.5rem;
  
  .modal-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: $accent-color;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 0;
      width: 50px;
      height: 3px;
      background: $accent-gradient;
      border-radius: 3px;
    }
  }

  .close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    color: $close-button-color;
    background: rgba($secondary-color, 0.2);
    border-radius: 50%;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      background: rgba($close-button-color, 0.1);
      color: $close-button-color;
      transform: rotate(90deg);
    }
  }
}

.modal-body {
  font-size: 1rem;
  color: $muted-text-color;
  padding: 2rem;
  line-height: 1.6;
}

.modal-footer {
  border-top: 1px solid rgba($accent-color, 0.1);
  padding: 1.25rem 2rem;
  
  .btn-secondary {
    background: transparent;
    border: 2px solid $accent-color;
    color: $accent-color;
    
    &:hover {
      background: rgba($accent-color, 0.1);
    }
  }
}

// Effektklassen
.effect-blur {
  backdrop-filter: blur(10px);
}

.effect-shadow {
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
}

.effect-border {
  border: 1px solid rgba($accent-color, 0.3);
}

.effect-glow {
  box-shadow: 0 5px 15px rgba($accent-color, 0.2);
  
  &:hover {
    box-shadow: 0 15px 30px rgba($accent-color, 0.4);
  }
}

// Responsive Anpassungen
@media (max-width: 992px) {
  .service-tabs .nav-pills {
    flex-wrap: wrap;
    
    .nav-item {
      margin-bottom: 0.5rem;
    }
  }
}

@media (max-width: 768px) {
  .services {
    padding: 60px 0;
  }
  
  .modal-dialog {
    margin: 0.5rem;
  }
}
</style>

